module.exports = __webpack_public_path__ + "img/javascript.e5643ff8.svg";